import { render, staticRenderFns } from "./DialogInformations.vue?vue&type=template&id=6a0237a2&scoped=true&"
import script from "./DialogInformations.vue?vue&type=script&lang=js&"
export * from "./DialogInformations.vue?vue&type=script&lang=js&"
import style0 from "./DialogInformations.vue?vue&type=style&index=0&id=6a0237a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0237a2",
  null
  
)

export default component.exports